/**
 * @desc 门店评分列表
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** page */
  page: number;
  /** page_size */
  page_size: number;
  /** 是否显示回复，0-显示全部, 1-只看回复 2-只看申诉 */
  show_code?: number;
  /** store_code */
  store_code?: string;
  /** store_id */
  store_id?: number;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<
    defs.store.GeneralHttpResponse<Array<defs.store.StoreReviewVOV2>>
  >(`/storeapi/api/v2/store/feedback/review/v3`, {
    params,
    method: 'get',
    ...(config || {}),
  });
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<
  Array<defs.store.StoreReviewVOV2>
>;
export default req;
